import { ErrorReport } from '~/types/common';
import { dashboardUserApi } from '~/utils/api';

export const reportError = async (error: ErrorReport) =>
  dashboardUserApi.post('/errors/ui', { ...error });
